export default __webpack_public_path__ + "330215d087808845d29a40eb966655f6.svg";